module.exports = __webpack_public_path__ + "static/media/eczema_leaflet@3x.07c0a58f.png";